import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateSessionNotification = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Session Notification'
      fields={fields}
      apiPath='admin/session_notifications'
      successRedirectPath={resource => `/write-now/session_notifications/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateSessionNotification
